<button
  class="menu-toggle"
  [ngClass]="{ disabled: disabled }"
  [matTooltip]="tooltip"
  matTooltipPosition="above"
  matTooltipTouchGestures="off"
>
  <svg class="menu-toggle-icon" [ngClass]="{ 'active-icon': active }">
    <use attr.href="assets/icons/{{ icon }}.svg#{{ icon }}"></use>
  </svg>
</button>
